import { Component, Input } from '@angular/core';

@Component({
  selector: 'nobis-button-state',
  templateUrl: './button-state.component.html',
  styleUrls: ['./button-state.component.scss']
})
export class ButtonStateComponent {
  @Input() mode = ''
}
